import { Link, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import "../Component/AdminDashboard.css";
import { API_BASE_URL } from "../config";

export default function AdminLayout() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const email = decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
        setUserName(email || "Unknown User");
      } catch {
        setUserName("Unknown User");
      }
    }
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.ok) {
        localStorage.clear();
        navigate("/");
        window.location.reload();
      } else {
        console.error("Logout failed");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Sidebar */}
      <aside className="sidebaar">
        <h2>Advocate Admin</h2>
        <nav>
          <ul>
            <li>Dashboard</li>
            <li>
              Manage Users
              <ul className="submenu">                
                <li><Link to="/admin/users">View Users</Link></li>
              </ul>
            </li>            
            <li>
              Manage Advocate
              <ul className="submenu">
                <li><Link to="/admin/advocate">View Advocate</Link></li>
              </ul>
            </li>
            <li>
              Manage Courts
              <ul className="submenu">
                <li><Link to="/admin/courts">View Court</Link></li>
              </ul>
            </li>
            <li>
              Manage Chambers
              <ul className="submenu">
                <li><Link to="/admin/chamber">View Chember</Link></li>
              </ul>
              </li>
            <li>
              Manage Case
              <ul className="submenu">
                <li>View Case</li>
                <li>Add Case</li>
                <li>Udate Case</li>
              </ul>  
            </li>
            <li>
              Manage Case Status
              <ul className="submenu">
                <li><Link to="/admin/status">View Status</Link></li>
              </ul>
            </li>
            <li>
              Manage Party
              <ul className="submenu">
                <li><Link to="/admin/party">View Party</Link></li>
              </ul>  
            </li>
            <li>Settings</li>
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <header className="header">
          <h1>Admin Dashboard</h1>
          <div className="user-info">
            <span>Welcome {userName}</span>
            <button onClick={handleLogout}>Logout</button>
          </div>
        </header>
        {/* Child Pages Load Here */}
        <Outlet />
      </main>
    </div>
  );
}
